<template>

  <div>
    <ContentsHeader>
      <template v-slot:title01>{{jobName}}</template>
      <template v-slot:explain01>
医療品メーカーや製薬企業に所属し、医療関係者に対して自社の医療用医薬品の適正情報を伝えるのが製薬の営業(MR)です。医療用医薬品の適正使用を促進するために医薬品の品質や有効性、安全性、副作用、利用する際の注意点などに関する情報を正確に提供することが求められます。また、新薬開発に活かすために、医療の現場から吸い上げたフィードバックを製品開発部門に提供することもMRの大事な役割です。新しい医療制度や法律、最新文献の知識など、より高いレベルの専門知識が求められるこの業界の営業職にはどんな特徴が見られるのでしょうか。
      </template>
      <template v-slot:yarigai01><span class="ddin">自社の医薬品により患者さんの命を救うことができる</span><span class="ddin">(石川県 37歳 男性)</span></template>
      <template v-slot:yarigai02><span class="ddin">医薬品を通じて医療機関、患者への貢献が感じ取れます</span><span class="ddin">(広島県 45歳 男性)</span></template>
      <template v-slot:yarigai03><span class="ddin">給与水準が高いことに加え、福利厚生が充実している</span><span class="ddin">(神奈川県 32歳 男性)</span></template>
      <template v-slot:img-headbg><img src="../assets/img/mr/headbg.svg" :alt="jobName" class="img"></template>
      <template v-slot:img-headp><img src="../assets/img/mr/person.svg" :alt="jobName" class="imgp -mr"></template>
    </ContentsHeader>

    <div class="contents-block">

      <section class="job-section">
        <div class="jsinner">
          <div class="block-two -aistretch -jcsb -bptablet">
            <div class="block -b48p -p0">
              <BalanceChartSection :explain="bcExplain" :radarData="radarData"></BalanceChartSection>
            </div>
            <div class="block -b48p -p0">
              <JobChangeRateSection
                :explain="jcExplain"
                :doughnutData="doughnutData"
                :doughnutDataFake="doughnutDataFake"
              ></JobChangeRateSection>
            </div><!-- .block -->
          </div><!-- .block-two -->
        </div><!-- .jsinner -->
      </section>

      <PersonalCharaSection :sevenData="sevenData" :secTtl="'製薬業界（MR）'" >
        <template v-slot:feature>外向的なゼネラリスト</template>
        <template v-slot:imgpup><img src="../assets/img/mr/person.svg" alt="不動産業界の営業" class="imgcvperson -mr"></template>
      </PersonalCharaSection>
    
      <div class="lb-area">
        <div class="lbinner block-two -bptablet">
          <div class="block">
            <CareerTypeSection :graphData="graphData" :explain="ctExplain" :jobName="'製薬(MR)'"></CareerTypeSection>
          </div><!-- .block -->
          <div class=" block">
            <SalesTypeSection :graph2Data="graph2Data" :explain="stExplain" :jobName="'製薬(MR)'"></SalesTypeSection>
          </div><!-- .block -->
        </div><!-- .block-two -->
      </div><!-- .lb-area -->

      <ResultSection :job="'mr'">
        <template v-slot:jobname>製薬業界(MR)の営業</template>
        <template v-slot:title01>オールマイティなバランサー</template>
        <template v-slot:explain01>
          人命に関わる情報を扱ったり、医療の専門家から情報を収集したりするという業務性質上、仲介役としての発信力や傾聴力、協調性などのバランスが重視されます。何か1つに突出していることよりも、すべての能力で安定したパフォーマンスを発揮できることが重要であると考えられます。
        </template>
        <template v-slot:title02>安定したキャリアを積みたい派多数</template>
        <template v-slot:explain02>
          安定したキャリアを重視する人が多く、計画的にものごとを進める傾向があります。
          <br />医療の現場を顧客とする製薬業界は、大きく景気に左右されることはほとんどなく、キャリアパスも明確化されています。着実にキャリアを積むうえでは適した環境だといえます。
        </template>
        <template v-slot:imgperson><img src="../assets/img/mr/person.svg" alt="不動産業界の営業" class="rsimg"></template>
      </ResultSection>

      <section class="other-section">
        <h2 class="osttl">その他の業界ごとの詳細をのぞく</h2>
        <div class="osinner">
          <DetailsList :job="'mr'"></DetailsList>
        </div><!-- .osinner -->
      </section>

    </div><!-- contents-block -->
  </div>

</template>

<script>
import ContentsHeader from "../components/ContentsHeader.vue";
import ResultSection from "../components/ResultSection.vue";
import DetailsList from "../components/DetailsList.vue";

import BalanceChartSection from "../components/BalanceChartSection.vue";
import JobChangeRateSection from "../components/JobChangeRateSection.vue";
import PersonalCharaSection from "../components/PersonalCharaSection.vue";
import CareerTypeSection from "../components/CareerTypeSection.vue";
import SalesTypeSection from "../components/SalesTypeSection.vue";

export default {
  data() {
    return {
      pageTitle: "製薬（MR）の営業をのぞく",
      pageURL: "mr",
      pageDescription: "SALES SALES SCOPEでは不動産、保険、ITなど人気10業界の営業職に人物特性と成績に関する調査を実施。医療品メーカーや製薬企業に所属し、医療関係者に対して自社の医療用医薬品の適正情報を伝えるのが製薬の営業(MR)です。新しい医療制度や法律、最新文献の知識など、より高いレベルの専門知識が求められるこの業界の営業職にはどんな特徴が見られるのでしょうか。",

      jobName: "製薬（MR）の営業",
      bcExplain: "計画性に長けたオールマイティ",
      jcExplain: "転職回数はやや少なめ",
      pcExplain: "外向的なゼネラリスト",
      ctExplain:
        "安定・保障された身分を望む安定タイプが多い\n個人として技能を磨く職人タイプは少ない",
      stExplain: "伝えるべき内容を重視するタイプが多い",
      radarData: [5.64, 5.75, 6.48, 7.93, 5.91],
      doughnutData: [55, 18, 15, 7, 5],
      doughnutDataFake: [55, 16, 13, 9, 7],
      sevenData: [6, 5, 4, 5, 5, 5, 3],
      graphData: [
        { num: 1, val: 3 },
        { num: 2, val: 7 },
        { num: 3, val: 15 },
        { num: 4, val: 31 },
        { num: 5, val: 7 },
        { num: 6, val: 10 },
        { num: 7, val: 17 },
        { num: 8, val: 10 },
      ],
      graph2Data: [
        { num: 1, val: 4 },
        { num: 2, val: 37 },
        { num: 3, val: 9 },
        { num: 4, val: 20 },
        { num: 5, val: 30 },
      ],
    };
  },
  components: {
    BalanceChartSection,
    JobChangeRateSection,
    PersonalCharaSection,
    CareerTypeSection,
    SalesTypeSection,
    ContentsHeader,
    ResultSection,
    DetailsList
  },
  metaInfo: {
    title: "製薬業界（MR）の営業をのぞく | 営業職の特徴を人物特性からのぞいてみた",
    titleTemplate: "%s | SALES SCOPE",
    htmlAttrs: {
      lang: "jp",
    },
  },
  mounted: function(){
    // document.title = title;
    document.querySelector("meta[name='description']").setAttribute('content', this.pageDescription);
    document.querySelector("meta[property='og:title']").setAttribute('content', this.pageTitle + " | 営業職の特徴を人物特性からのぞいてみた | SALES SCOPE");
    document.querySelector("meta[property='og:description']").setAttribute('content', this.pageDescription);
    document.querySelector("meta[property='og:url']").setAttribute('content', 'https://sales-score.jp/scope/' + this.pageURL);
  }
};
</script>